// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"PermissionsTableRow_tableRow__1c3ay","tag":"PermissionsTableRow_tag__2HLJW","offset":"PermissionsTableRow_offset__12DW7","tooltip":"PermissionsTableRow_tooltip__1c2w8"};